import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/auth/login",
    name: "auth.login",
    component: () => import("@/modules/auth/views/LoginView.vue"),
    meta: {
      requiresAuth: false,
    },
  },
];
